import React from "react";

type ProfileImageProps = {
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  borderOutlineColor?: string;
};

const MonkeyProfileFruit = ({ color, width, height, style, borderOutlineColor }: ProfileImageProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="-2 -2 184 184"
    fill="none"
    style={style}
  >
    <g clipPath="url(#clip0_440_12538)">
      <path
        d="M90 179C139.1533 179 179 139.1533 179 90C179 40.8467 139.1533 1 90 1C40.8467 1 1 40.8467 1 90C1 139.1533 40.8467 179 90 179Z"
        fill="var(--jungle-art-avatar-disc, #FBFFDF)"
        stroke={borderOutlineColor}
        strokeWidth={borderOutlineColor ? 1 : 0}
      />
      <mask
        id="mask0_440_12538"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="180"
        height="180"
      >
        <path
          d="M90 179C139.1533 179 179 139.1533 179 90C179 40.8467 139.1533 1 90 1C40.8467 1 1 40.8467 1 90C1 139.1533 40.8467 179 90 179Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_440_12538)">
        <path
          d="M162.85 187.42C163.33 187.73 163.79 186.94 163.82 186.36C164.13 180.48 161.35 174.89 158.39 169.8C153.42 161.26 147.79 153.13 141.6 145.42C140.09 143.54 138.52 141.68 136.58 140.26C135.18 139.23 130.22 131.67 128.51 131.59C126.8 131.51 128.18 138.32 127.54 140.24C127.04 141.74 126.65 143.27 126.85 144.84C128.25 156.11 126.95 167.91 129.97 178.86C130.26 179.86 130.54 180.89 131.14 181.74C132.42 183.57 134.73 184.28 136.9 184.88C142.01 186.31 147.11 187.7 152.19 189.13C154.3 189.73 156.44 190.3 158.64 190.24C160.84 190.18 161.52 189.18 162.86 187.44V187.41L162.85 187.42Z"
          fill="#894C0A"
        />
        <path
          d="M157.48 169.91C159.78 169.91 161.86 171.05 163.34 172.82C163.96 173.56 165.06 174.16 165.44 175.16C165.67 175.76 165.55 176.53 165.04 176.9C164.47 177.3 163.67 177.1 162.99 177.16C161.88 175.88 160.31 175.05 159.03 173.94C158.52 173.48 158.03 172.97 157.75 172.34C157.55 171.86 157.46 171.34 157.41 170.83C157.35 170.49 157.5 170.26 157.47 169.92H157.5L157.48 169.91Z"
          fill="#894C0A"
        />
        <path
          d="M164.98 186.37C165.12 183.66 164.58 181.01 163.7 178.47C164.21 178.47 164.7 178.56 165.13 178.21C165.64 177.81 165.76 177.07 165.53 176.47C165.3 175.87 164.82 175.41 164.33 174.99C163.36 174.19 162.33 173.48 161.25 172.85C160.85 172.08 160.19 170.94 159.77 170.17C157.69 170.48 155.78 170.94 153.89 172.05C152.81 172.71 151.81 173.5 150.95 174.42C148.15 177.39 146.93 181.89 146.99 185.97C146.99 186.43 147.05 186.91 147.1 187.37C149.18 187.94 151.26 188.54 153.35 189.14C155.46 189.74 157.63 190.31 159.8 190.25C161.97 190.19 162.65 189.19 163.99 187.45C164.47 187.76 164.96 186.97 164.99 186.37H164.98Z"
          fill="#FFD39F"
        />
        <path
          d="M121.91 114.6C128.16 122.33 134.92 138.79 135.32 148.69C136.2 169.88 133.78 185.8 141.02 205.74C143.19 211.7 143.3 217.83 143.87 224.17C144.81 234.67 145.5 246.19 139.31 254.75C135.92 259.46 130.75 262.65 125.25 264.53C119.74 266.41 113.93 267.01 108.14 267.27C90.85 268.07 73.43 266.01 56.8 261.14C47.42 258.4 38.26 255.04 32.04 247.48C27.93 242.49 26.48 235.73 26.48 229.25C26.48 222.77 27.85 216.39 28.7 209.94C31.18 191.48 29.7 172.46 34.72 154.55C36.94 146.56 40.42 139 43.88 131.47C44.28 130.61 44.74 129.67 45.62 129.3C51.04 121.28 59.4 116.52 68.67 113.73C77.94 110.93 87.7 110.48 97.37 110.56C102.56 110.62 107.84 110.82 112.77 112.41C115.99 113.44 118.59 113.92 121.9 114.58L121.93 114.61L121.91 114.6Z"
          fill="#9B5808"
        />
        <path
          d="M84.48 231.84C84.31 234.49 86.25 236.92 88.62 238.09C90.99 239.26 93.73 239.4 96.38 239.4C102.17 239.34 107.96 238.57 113.58 237.12C117.49 236.09 121.65 234.72 125.67 235.15C129.09 234.12 130.83 230.39 132.03 227.02C134.2 220.94 135.99 214.7 136.51 208.28C137.03 201.86 135.57 195.53 132.94 189.65C127.24 176.81 133.51 161.35 128.92 148.06C128.06 145.61 126.87 143.27 125.07 141.41C121.56 137.73 116.14 136.3 111.06 136.73C105.98 137.16 101.19 139.24 96.74 141.69C94.89 142.72 93.09 143.8 91.46 145.11C86.9 148.85 83.99 154.29 82.33 159.97C80.68 165.65 80.19 171.58 79.71 177.46C78.45 192.78 78.2 208.38 80.85 223.53C81.39 226.55 82.28 229.72 84.47 231.83L84.48 231.84Z"
          fill="#BE8960"
        />
        <path
          d="M130.52 58.6401C131.49 50.2801 145.18 46.9201 152.34 46.8001C171.42 46.4901 173.59 70.1001 167.63 83.1701C164.06 91.7301 150.4 98.9701 143.61 89.6701C135.97 80.8001 128.12 70.9901 130.52 58.6401Z"
          fill="#894C0A"
        />
        <path
          d="M134.29 61.2301C135 55.1801 144.87 52.7601 150.06 52.6701C163.84 52.4401 165.43 69.5301 161.13 78.9701C158.53 85.1601 148.69 90.3801 143.76 83.6801C138.23 77.2601 132.55 70.1901 134.29 61.2301Z"
          fill="#BE8960"
        />
        <path
          d="M98.7997 44.1502C72.9597 38.7602 43.0297 46.2602 32.8797 73.1302C18.9897 108.79 35.1597 137.74 75.7497 134.12C97.5997 131.61 130.8 127.56 143.9 109.3C151.86 97.6302 150.86 81.3202 144.44 69.1902C135.48 52.8202 117.14 47.1102 99.3397 44.2302L98.7997 44.1402V44.1502Z"
          fill="#9B5808"
        />
        <path
          d="M61.3499 67.2302C54.4499 58.1602 40.5599 52.8302 29.3499 54.8802C18.1399 56.9302 10.2699 61.7002 7.01993 72.6202C5.73993 76.9002 6.90993 84.8602 8.18993 89.1102C10.0699 95.4702 15.3799 100.41 21.4299 103.17C27.4799 105.93 30.8399 107.31 37.4899 107.51C43.4799 107.68 54.4099 107.4 59.5099 104.23C61.6799 100.35 60.9399 97.2102 60.6499 92.7902C60.4499 89.9402 60.2499 83.5202 60.3599 80.6702C60.5899 74.5702 62.0699 73.3102 61.4199 67.2302H61.3599H61.3499Z"
          fill="#9B5808"
        />
        <path
          d="M58.13 72.2701C47.32 54.6401 13.83 61.6301 19.88 84.5601C22.62 97.7401 39.7 100.36 51.88 96.9401C61.86 93.6001 55.84 86.2701 58.7 73.4401L58.13 72.2701Z"
          fill="#BE8960"
        />
        <path
          d="M130.32 115.72C135.68 113.52 141.22 108.28 143.24 103.17C146.81 94.2702 146.38 84.1702 143.38 75.0402C141.47 69.1902 138.99 62.8302 133.25 59.7802C131.22 58.7002 128.91 58.0702 126.66 58.4102C124.41 58.7502 122.24 60.1502 121.38 62.2902C120.98 63.2902 120.87 64.4302 120.12 65.2302C119.37 66.0302 118.67 66.0602 117.55 64.9402C112.36 59.5802 105.51 55.6702 98.04 55.5002C92.25 55.3902 86.57 57.5802 81.7 60.6902C77.71 63.2002 74.4 65.5402 71.06 70.7002C66.66 77.5302 65.49 86.0202 67.4 93.9302C68.95 100.37 75.31 108.23 81.09 111.47C87.24 114.92 93.79 117.89 100.79 118.87C104.13 119.33 107.49 119.44 110.83 119.47C113.34 119.5 115.88 119.53 118.39 119.21C122.5 118.7 126.46 117.27 130.28 115.7H130.31L130.32 115.72Z"
          fill="#FFD29F"
        />
        <path
          d="M89.3002 68.5601C87.5902 68.4501 85.8801 68.6701 84.2501 69.5901C83.4201 70.0501 82.6002 70.7001 82.0502 71.9601C81.6502 72.9001 81.4202 74.1601 81.4802 75.3501C81.5402 76.5401 81.7901 77.7701 82.2501 78.6001C83.0201 80.0301 84.1601 80.3701 85.2201 80.1701C86.5001 79.9101 87.7301 78.8901 88.7001 77.2901C89.1001 76.6301 89.4401 75.8901 89.7001 74.9801C89.9001 74.1501 90.0101 73.2401 90.1001 72.3301C90.1601 71.8201 90.1902 71.3301 90.1602 70.8201C90.1002 70.0501 89.8701 69.3401 89.5301 68.9101C89.1901 68.4801 88.7601 68.3701 88.3601 68.6001"
          fill="#5C2600"
        />
        <path
          d="M88.6901 68.7303C81.3601 72.9803 84.2101 83.3103 92.1401 84.9003C100.07 86.5003 107.71 77.7703 103.69 71.7203C100.12 66.2103 93.8501 66.4402 88.6901 68.7002V68.7303Z"
          fill="#FAF6D6"
        />
        <path
          d="M92.0699 69.4202C87.1399 72.7302 88.7899 81.8902 94.5799 83.2502C100.37 84.6202 105.93 77.1502 102.99 71.9502C100.39 67.2402 93.8299 65.9002 92.0699 69.4102V69.4202Z"
          fill="#522E2D"
        />
        <path
          d="M137.03 63.0602C137.89 62.9502 138.77 63.1702 139.63 63.9402C140.06 64.3402 140.46 64.8802 140.74 65.9902C140.94 66.8202 141.05 67.8702 141.03 68.9302C141.01 69.9902 140.86 71.0102 140.63 71.7502C140.23 72.9802 139.66 73.2902 139.12 73.1202C138.46 72.8902 137.84 72.0102 137.35 70.6102C137.15 70.0402 136.95 69.3802 136.84 68.6102C136.73 67.9002 136.67 67.1002 136.64 66.3002C136.64 65.8702 136.61 65.4202 136.64 64.9902C136.64 64.3102 136.78 63.7102 136.95 63.3402C137.12 62.9702 137.35 62.8802 137.55 63.0802"
          fill="#5C2600"
        />
        <path
          d="M137.18 63.2302C140.92 66.9102 139.46 75.8402 135.41 77.2402C131.36 78.6402 127.45 71.0502 129.51 65.8602C131.34 61.1002 134.53 61.3002 137.18 63.2602V63.2302Z"
          fill="#FAF6D6"
        />
        <path
          d="M137.18 63.8802C139.98 67.0702 139.03 75.9202 135.75 77.2302C132.47 78.5402 129.27 71.3302 130.96 66.3602C132.44 61.8202 136.18 60.5402 137.18 63.9102V63.8802Z"
          fill="#522E2D"
        />
        <path
          opacity="0.1"
          d="M70.1902 104.31C74.1502 100.72 79.7202 99.4001 85.0502 99.2601C88.3602 99.1701 91.7802 99.4901 94.6602 101.11C97.4802 102.71 99.5102 105.42 100.96 108.3C103.1 112.55 104.1 117.74 101.96 121.99C100.11 125.64 96.4802 129.01 92.5502 130.12C87.2202 131.6 83.9902 131.43 80.0602 130.26C75.6402 128.95 69.4802 126.35 67.1102 122.07C64.4002 117.19 66.2502 107.86 70.2202 104.3H70.1902V104.31Z"
          fill="#FF5580"
        />
        <path
          opacity="0.1"
          d="M144.36 110.01C147.01 105.9 148.58 101.28 149.24 96.4601C148.87 94.3201 148.21 92.3501 147.39 91.2101C145.39 88.4701 142.57 87.4401 139.86 87.3301C138.18 87.2401 136.44 87.5001 134.98 88.7601C133.55 89.9901 132.53 92.0701 131.79 94.2701C130.71 97.5201 130.19 101.52 131.28 104.74C132.22 107.54 134.08 110.1 136.07 110.96C138.78 112.1 140.41 111.96 142.4 111.07C143.03 110.78 143.71 110.44 144.4 110.01H144.37H144.36Z"
          fill="#FF5580"
        />
        <path
          d="M123.13 78.8602C129.58 74.3202 127.41 68.9902 121.13 70.1902C114.6 71.3302 114.71 77.2902 122.61 78.9802L123.12 78.8702L123.13 78.8602Z"
          fill="#522E2D"
        />
        <path
          d="M72.6501 43.2902C72.6501 43.2902 80.1501 31.9402 86.5701 31.9402C85.9401 35.1302 85.9401 37.6202 85.9401 37.6202L90.3301 36.7402C90.3301 36.7402 82.7401 41.5602 101.94 44.7602C85.9401 47.9502 72.6701 43.3302 72.6701 43.3302L72.6401 43.3002L72.6501 43.2902Z"
          fill="#9B5808"
        />
        <path
          d="M117.4 97.4902C119.51 98.8002 120.99 99.5402 123.48 99.4002C125.59 99.2902 126.96 98.9202 128.44 97.4302"
          stroke="#522E2D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M122.79 78.6301L124.02 91.7201C124.28 94.4301 124.13 95.5701 123.51 99.3901"
          stroke="#522E2D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M84.3401 153.91C81.0001 158.59 81.0001 165.41 84.3401 170.08C85.7901 172.11 87.7602 173.73 89.8202 175.19C92.3602 177.02 95.0402 178.64 97.7202 180.3C105.19 184.86 112.64 189.46 120.11 194.02C123.5 196.1 127.16 198.5 128.47 202.26C128.9 203.52 129.04 204.86 128.95 206.2C128.78 208.4 127.84 210.71 125.9 211.76C124.73 212.42 123.33 212.53 121.99 212.47C119.82 212.38 117.68 211.84 115.57 211.3C106.56 209.02 97.5101 206.76 88.5901 204.17C77.2901 200.89 65.4302 196.61 58.4702 187.17C55.2802 182.83 53.3402 177.7 51.4502 172.62C49.9702 168.63 51.9602 164.01 52.9302 159.84C53.3602 158.01 53.7902 156.19 54.5602 154.51C56.7302 149.72 61.3501 146.44 66.2001 144.33C68.3701 143.39 70.6802 142.59 73.0502 142.48C75.4202 142.37 77.9001 142.96 79.7001 144.53C82.5001 146.93 83.9202 150.29 84.3801 153.94L84.3502 153.91H84.3401Z"
          fill="#9B5808"
        />
        <path
          d="M51.26 23.2401C51.65 22.6801 51.94 22.0901 52.36 21.5501C62.44 33.8601 79 39.5501 94.32 33.9701C104.15 30.3901 112.65 22.7301 116.06 12.7101C116.6 12.9401 117.75 13.0801 118 12.3701C121.1 19.5001 117.66 27.6101 112.79 33.0101C101.92 45.0601 82.29 48.2701 67.25 43.1801C59.14 40.4201 48.32 33.2701 51.22 23.2101L51.25 23.2401H51.26Z"
          fill="#FACC24"
        />
        <path
          d="M115.13 12.03C115.02 12.63 115.59 13.31 116.13 13.54C112.68 23.67 104.06 31.45 94.1104 35.08C78.5904 40.73 61.8204 34.97 51.6104 22.5V22.44C52.1504 21.76 52.7503 21.36 53.4604 20.87C58.2503 22.18 58.4503 23.09 61.5303 25.01C62.7603 25.78 64.0104 26.58 65.3004 27.23C80.8704 35.56 96.2504 31.48 107.92 19.04C110.2 16.59 112 13.42 115.17 12.02H115.14L115.13 12.03Z"
          fill="#FBE56B"
        />
        <path
          d="M49.0001 13.1602C49.0001 13.1602 48.4901 15.3002 48.4001 15.5002C48.2601 15.8702 47.5701 16.7802 47.2901 17.0402C46.3201 17.8402 44.6901 18.1502 43.4701 17.9502C43.2701 17.7802 43.3301 17.8402 43.2101 17.6102C42.6401 16.4702 47.8901 12.4202 48.8601 12.9602C49.1201 13.1002 49.0001 12.8702 48.9701 13.1602H49.0001Z"
          fill="#613428"
        />
        <path
          d="M53.76 21.3701C53.05 21.8501 52.45 22.2501 51.91 22.9401L47.29 17.0101C47.6 16.7501 48.26 15.8401 48.4 15.4701C48.49 15.3001 49 13.2501 49 13.1301C49.68 14.3001 50.03 15.7801 50.57 17.0401C51.43 18.9501 52.14 20.0101 53.74 21.3501L53.77 21.3801L53.76 21.3701Z"
          fill="#84B342"
        />
        <path
          d="M51.9002 22.9703V23.0303C51.4702 23.5703 51.1902 24.1703 50.7902 24.7403C48.9402 21.2003 46.2502 20.3803 43.4902 17.9503C44.7202 18.1503 46.3402 17.8403 47.3102 17.0403L51.9302 22.9703H51.9002Z"
          fill="#84B342"
        />
        <path
          d="M118.11 13.2501C117.85 13.9601 116.68 13.8201 116.14 13.5901C115.6 13.3601 115.03 12.6801 115.14 12.0801C115.37 11.0001 117.96 12.1901 118.11 12.5101C118.22 12.7701 118.2 13.0201 118.11 13.2801V13.2501Z"
          fill="#613428"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_440_12538">
        <rect width="180" height="180" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MonkeyProfileFruit;
